<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Edit User Id</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col sm="4" md="4" cols="12">
                    <v-autocomplete clearable rounded outlined dense v-model="username" :items="userlist"
                        item-text="username" item-value="id" label="Search User" persistent-hint
                        single-line></v-autocomplete>
                </v-col>
                <v-col sm="2" md="2" cols="12">
                    <v-btn class="button" :disabled="isallowed == false ? true : false"
                        @click="getUsernameInfo()">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="username_edit!=null">
                <v-col cols="12" md="4" sm="4">
                    <v-text-field label="Current Username" v-model="username_edit" rounded outlined dense readonly
                        filled> </v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="4">
                    <v-text-field label="New Username " 
                        :hint="'Enter new user user id like xxx'+this.uid_domain" persistent-hint
                        v-model="username_edit_final" rounded outlined dense> </v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="username_edit!=null && username_edit_final!=null">
                <v-col sm="2" md="2" cols="12">
                    <v-btn class="button" @click="saveUsernameInfo()">Update</v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            errorMsg: { username: false, userType: false },
            search: "",
            snackbar_msg: "",
            color: "",
            // extraBreadcrumbItems: [
              

            // ],
            breadcrumbClass: "breadcrumb-style1",
            snackbar: false,
            uid_domain: "",
            load: false,
            overlay: false,
            dialog: false,
            userlist: [],
            username: "",
            username_edit:null,
            username_edit_final:null,isallowed:false,
            rules: {
                    required: value => !!value || 'Required.',
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Invalid e-mail.'
                    },
                },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New User" : "Edit User";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
        },
        mounted() {
            this.overlay = true;
            axios
                .post("/roleManagement/getUserToChangeId")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.userlist = res.data.userlist;
                        this.uid_domain = res.data.uid_domain;
                        this.load = true;
                        this.isallowed=res.data.isallowed
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                         this.isallowed=res.data.isallowed
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    window.console.log(error);
                    this.overlay = false;
                });
        },

        methods: {
            hasWhiteSpace(s) {
                var status = false;
                var reWhiteSpace = new RegExp(/^\s+$/);

                // Check for white space
                if (reWhiteSpace.test(s)) {
                    // alert("Please Check Your Fields For Spaces");
                    return true;
                }
                return false;
            },
            validEmail(email) {
                //alert("in valid")
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(email)) {
                       // alert("Please Check Your email id");
                        return true;
                    }
                return false;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getUsernameInfo(){
                const data = {
                    username :this.username
                }
                axios
                .post("/roleManagement/getUsernameInfo",data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.username_edit = res.data.username_edit
                    } 
                    else {
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong");
                });
            },
            saveUsernameInfo() {
                if(this.hasWhiteSpace(this.username_edit_final)){
                    this.showSnackbar("#b71c1c", "Please Enter user Id");
                    return
                 }
                //  if(!this.validEmail(this.username_edit_final)){
                //     this.showSnackbar("#b71c1c", "Please Enter Valid User Id");
                //     return
                //  }
                 const data = {
                    username :this.username,
                    // new_username :this.username_edit_final += this.uid_domain
                    new_username :this.username_edit_final
                }
                axios
                .post("/roleManagement/saveUsernameInfo",data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                       this.showSnackbar("#4caf50", "User Updated Successfully...");
                    } 
                    else {
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong");
                });
            },
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
